import { observable } from "mobx";
import { Type } from "class-transformer";
import type { IRefund } from "./types";
import RefundPermittedActionsResponse from "./refundPermittedActionsResponse";
import RefundApprovalResponse from "./refundApprovalResponse";
import RefundChargeResponse from "./refundChargeResponse";
import RefundOriginalPayGatePaymentResponse from "./refundOriginalPayGatePaymentResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class PayGateRefundResponse {
  id!: string;

  @observable
  refundPaymentTemplateId!: string;

  @observable
  refundAmount!: number;

  @observable
  @Type(() => RefundChargeResponse)
  charge?: RefundChargeResponse;

  @observable
  @Type(() => RefundPermittedActionsResponse)
  permittedActions!: RefundPermittedActionsResponse;

  @observable
  @Type(() => RefundApprovalResponse)
  approvals!: RefundApprovalResponse[];

  @observable
  officialRecordId?: string;

  @observable
  @Type(() => RefundOriginalPayGatePaymentResponse)
  originalPayment?: RefundOriginalPayGatePaymentResponse;

  @observable
  payGatePaymentIdent?: string;
}

export default class PayGateRefund extends PayGateRefundResponse implements IRefund {
  @observable
  returnFee?: number;

  @observable
  isSelectable: boolean;
}
